import { font } from '@approvalmax/ui';
import { ExchangeRateWithUpdate } from 'pages/requestForm/components/ExchangeRateWithUpdate/ExchangeRateWithUpdate';
import styled from 'styled-components';

export const DropdownEditorContainer = styled.div`
    margin: -3px;
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 80px;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
`;

export const LineAmountTypeWrapper = styled.div`
    display: flex;
    align-items: center;
    text-transform: none;
    margin-left: 10px;
`;

export const LineAmountTypeLabel = styled.div`
    margin-right: 10px;
    ${font(12, '#a0a1a1')}
`;

export const StyledExchangeRateWithUpdate = styled(ExchangeRateWithUpdate)`
    margin-right: 10px;
    margin-left: 10px;
    text-transform: none;
    ${font(14, '#7f7d7d')}
`;
